import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { createCompany, companyCreated } from 'actions/company';

import NotFound from 'components/NotFound';
import NavBarConfig from 'components/NavBarConfig';
import CompanyCreate from 'components/company/CompanyCreate';

const messages = defineMessages({
  BACK: {
    id: 'CompanyCreatePage.BACK',
    defaultMessage: 'Zurück',
  },
  CREATE_COMPANY: {
    id: 'CompanyCreatePage.CREATE_COMPANY',
    defaultMessage: 'Neues Unternehmen anlegen',
  },
  CREATE_COMPANY_DESC: {
    id: 'CompanyCreatePage.CREATE_COMPANY_DESC',
    defaultMessage: 'Legen Sie hier ein neues Unternehmen an.',
  },
});

@injectIntl
@connect(
    state => ({ locale: state.intl.locale }),
    dispatch => ({
        submit: formData => createCompany(formData).then(company => {
            dispatch(companyCreated(company));
            dispatch(push(`/company/${company.id}/`));
        }),
    })
)

export default class CompanyCreatePage extends React.PureComponent {
    render() {
        const { locale, user, intl: { formatMessage } } = this.props;
        if (!user.is_admin) {
            return <NotFound />;
        }
        return (
            <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
                <NavBarConfig
                  companyList
                  createPage
                  currentRouteName={this.props.routes[this.props.routes.length - 1].name}
                />
                <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
                  <div style={{ maxWidth: '1000px' }}>
                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
                      <Link to={`/`} onMouseDown={e => e.preventDefault()} style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--btn-default-bg)', border: '1px solid var(--btn-default-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-color)', textDecoration: 'none', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                        <i className="fa fa-arrow-left" />
                      </Link>
                      <div>
                        <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>{formatMessage(messages.CREATE_COMPANY)}</h2>
                        <p style={{ margin: '4px 0 0 0', color: 'var(--text-muted)' }}>{formatMessage(messages.CREATE_COMPANY_DESC)}</p>
                      </div>
                    </div>

                    {/* Main Card */}
                    <div style={{ position: 'relative' }}>
                      {/* Glow Aura */}
                      <div style={{ position: 'absolute', top: '-10px', left: '-10px', right: '-10px', bottom: '-10px', background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(147, 51, 234, 0.2) 100%)', filter: 'blur(24px)', zIndex: 0, borderRadius: '32px' }} />
                      
                      <div style={{ position: 'relative', zIndex: 1, backgroundColor: 'var(--panel-bg)', borderRadius: '24px', boxShadow: 'var(--glass-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
                        <div style={{ padding: '32px' }}>
                          <div style={{ maxWidth: '600px' }}>
                            <CompanyCreate
                              initialValues={{ locale }}
                              onSubmit={this.props.submit}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        );
    }
}
